/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class DropdownButton extends React.Component {
    render() {
        var controlClass = classnames('control', 'drop-down-button', this.props.controlClass),
            labelClass = classnames('drop-down-label', this.props.labelClass),
            label = null;

        if (this.props.label !== '') {
            label = (
                <div className="label-wrapper">
                    {this.props.label}
                </div>
            );
        }

        return (
            <div className={controlClass} onClick={this.props.action} role="button" aria-label={this.props.ariaLabel || this.props.label}>
                <div className={labelClass}>
                    <span className="va-helper"></span>
                    {label}
                </div>
            </div>
        );
    }

};

export default DropdownButton;
